import { createRouter, createWebHistory } from "vue-router";
import pageSeo from "@/config/page-seo.json";

const routes = [
  {
    path: "/layout",
    name: "layout",
    redirect: "/",
    component: () => import("@/views/layout/index.vue"),
    children: [
      {
        path: "/",
        name: "/",
        component: () => import("@/views/home/index.vue"),

      },
      {
        path: "/about",
        name: "/about",
        component: () => import("@/views/about/index.vue"),

      },
      {
        path: "/case",
        name: "/case",
        component: () => import("@/views/case/index.vue"),

      },
      {
        path: "/serve",
        name: "/serve",
        component: () => import("@/views/serve/index.vue"),

      },
      {
        path: "/listCase/:name?",
        name: "listCase",
        component: () => import("@/views/list-case/index.vue"),

      },
      {
        path: "/newsInformation",
        name: "newsInformation",
        component: () => import("@/views/news-information/index.vue"),

      },
      {
        path: "/newsInformationDetail",
        name: "newsInformationDetail",
        redirect: (to) => /^\d+$/.test(String(to.query.id || ""))
          ? { name: "newsArticle", params: { id: String(to.query.id) } }
          : { name: "newsInformation" },
      },
      {
        path: "/news/:id(\\d+)",
        name: "newsArticle",
        component: () => import("@/views/news-information-detail/index.vue"),
      },
      {
        path: "/imitatepage",
        name: "imitatepage",
        component: () => import("@/views/imitatepage/index.vue"),
      },
      {
        path: "/trialDemo",
        name: "trialDemo",
        component: () => import("@/views/demo/index.vue"),

      },
      {
        path: "/webFramework",
        name: "webFramework",
        component: () => import("@/views/web-framework/index.vue"),
      },
      {
        path: "/richHtml/:caseName",
        name: "richHtml",
        component: () => import("@/views/richHtml/index.vue"),
      },
      {
        path: "/:pathMatch(.*)*",
        name: "notFound",
        component: () => import("@/views/not-found/index.vue"),
        meta: { noindex: true },
      },
    ],
  },
];

// 与静态快照共用栏目元信息，防止构建后和站内跳转后的标题、描述不一致。
routes[0].children.forEach((route) => {
  if (pageSeo[route.path]) route.meta = pageSeo[route.path];
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

export default router;
